import React from 'react'
import PropTypes from 'prop-types'
import RegisteredFormField from '../../../common/RegisteredFormField'
import { YES_NO } from '../../../../constant/YES_NO'

const YesNoSelect = ({ id, path, label }) => {
  return <RegisteredFormField
    id={id}
    inputType='select'
    options={YES_NO}
    label={label}
    path={path}
    placeholder=' '
  />
}

YesNoSelect.propTypes = {
  /** A unique element id */
  id: PropTypes.string,
  /** The redux object full path for this form field */
  path: PropTypes.string.isRequired,
  /** A label this form field */
  label: PropTypes.node
}

export default YesNoSelect